import React from 'react'
import { Button, Spinner } from 'reactstrap'

interface TriggerRemittanceButtonProps {
  isLoading: boolean
  isDisabled: boolean
  onTrigger: () => void
}

const TriggerRemittanceButton: React.FC<TriggerRemittanceButtonProps> = ({
  isLoading,
  isDisabled,
  onTrigger,
}) => {
  return (
    <Button
      color="primary"
      size="sm"
      disabled={isDisabled || isLoading}
      onClick={onTrigger}
    >
      {isLoading ? (
        <>
          <Spinner size="sm" className="me-2" />
          Triggering...
        </>
      ) : (
        <>
          <i className="fas fa-paper-plane me-2"></i>
          Trigger Remittance
        </>
      )}
    </Button>
  )
}

export default TriggerRemittanceButton
